/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
 * @restrict E
 * @description Componente che gestisce il secondo sotto-step "Integrazione
 *              Anagrafica" dello step "Valutazione"
 */
(function() {
  'use strict';
  var CreasIntegrazioneAnagraficaCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    $cacheFactory,
    $location,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$cacheFactory = $cacheFactory;
    this.$location = $location;
    this.messaggiFctr = messaggiFctr;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    this.datiFirmatario = null;
    this.datiTitolari = null;
    this.datiCliente = null;

    // Spinner
    this.spinner = this.dettPraticaSrvc.spinner;
    this.subSpinner = {
      cliente: false,
      firmatari: false,
      titolari: false
    };

    this.esiti = {
      cliente: false,
      firmatari: false,
      titolari: false
    };

    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
    dettPraticaSrvc.isSaveEnabled = function() {
      return false;
    };

    dettPraticaSrvc.isPrevEnabled = function() {
      return true;
    };

    dettPraticaSrvc.isNextEnabled = function() {
      return self.esiti.cliente === true && self.esiti.firmatari === true && self.esiti.titolari === true;
    };

    dettPraticaSrvc.nextStep = function() {
      self.spinner.pratica = true;
      $q
        .all({
          nextStep: dettPraticaSrvc.promiseCambiaStep('/passaSceltaConto')
        })
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response.nextStep)) {
              return;
            }
            
            dettPraticaSrvc.datiPratica = response.nextStep.data.result;
            dettPraticaSrvc.generaTabs();
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.nextStep);
          }
        )
        .finally(function() {
          self.spinner.pratica = false;
        });
    };

    var self = this;

    /**
	 * @ngdoc method
	 * @name promiseIntegrazioneFirmatari
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
	 * @description Effettua una chiamata http per eseguire l'integrazione dei
	 *              dati dei firmatari nel DB Banca
	 * @return {Promise} - Ritorna una promise contenente l'esito
	 *         dell'integrazione
	 */
    this.promiseIntegrazioneFirmatari = function() {
      return this.$http({
        method: 'POST',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.INTEGRAZIONE.FIRMATARI
      });
    };

    /**
	 * @ngdoc method
	 * @name promiseIntegrazioneCliente
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
	 * @description Effettua una chiamata http per eseguire l'integrazione dei
	 *              dati del cliente nel DB Banca
	 * @return {Promise} - Ritorna una promise contenente l'esito
	 *         dell'integrazione
	 */
    this.promiseIntegrazioneCliente = function() {
      return this.$http({
        method: 'POST',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.CLIENTI.INTEGRAZIONE.CLIENTE
      });
    };

    /**
	 * @ngdoc method
	 * @name recuperaDatiCliente
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
	 * @description Esegue il recupero dei dati del cliente e dei firmatari
	 */
    this.recuperaDatiCliente = function() {
      self.subSpinner.firmatari = true;
      CblBrioLoader.hideLoader();
      $q
        .all({
          datiCliente: self.dettPraticaSrvc.promiseDatiClienteIntegrazione()
        })
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response.datiCliente)) {
              return;
            }
            
            // Titolari
            self.esiti.titolari = true;
            
            if (
              response.datiCliente.data.result.titolari &&
              response.datiCliente.data.result.titolari.length > 0
            ) {
              self.datiTitolari = [];
              for (
                var i = 0;
                i < response.datiCliente.data.result.titolari.length;
                i++
              ) {
                self.datiTitolari.push(
                  response.datiCliente.data.result.titolari[i]
                );
                
                if (
                  response.datiCliente.data.result.titolari[i].prospetto
                    .stato === 'INCORSO'
                ) {
                  self.esiti.titolari = false;
                }
              }
            }
            
            // Firmatario
            self.datiFirmatario = response.datiCliente.data.result.firmatario;
            
            if (self.datiFirmatario && self.datiFirmatario.prospetto && (
              self.datiFirmatario.prospetto.stato === 'INCORSO')
            ) {
              self.esiti.firmatari = false;
            } else {
              self.esiti.firmatari = true;
            }

            // Persona Giuridica
            self.datiCliente = response.datiCliente.data.result.giuridica;
            if (
              self.datiCliente.prospetto.stato === 'INCORSO'
            ) {
              self.esiti.cliente = false;
            } else {
              self.esiti.cliente = true;
            }
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.datiCliente);
          }
        )
        .finally(function() {
          self.subSpinner.firmatari = false;
        });
    };
    
    /**
	 * @ngdoc method
	 * @name integrazioneSocietaAbilitata
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
	 * @description Verifica se è possibile eseguire l'integrazione dei dati della società
	 * Sarà possibile eseguirla quando sia i dati del titolare, sia dei firmatari sono integrati
	 */
    this.integrazioneSocietaAbilitata = function() {
    	
    	// Verifico, se presente, il firmatario
    	if (this.datiFirmatario && this.datiFirmatario.prospetto && this.datiFirmatario.prospetto.stato === 'INCORSO') {
				return false;
    	}
    	
    	// Verifico, se presenti, i titolari
    	if (this.datiTitolari && this.datiTitolari.length && this.datiTitolari.length > 0) {
    		for(var i = 0; i < this.datiTitolari.length; i++) {
    			if (this.datiTitolari[i].prospetto.stato === 'INCORSO') {
    				return false;
    			}
    		}
    	}
    	
    	return true;
    }

    /**
	 * @ngdoc method
	 * @name eseguiIntegrazioneFirmatari
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
	 * @description Esegue l'integrazione dei dati dei firmatari
	 */
    this.eseguiIntegrazioneFirmatari = function(firmatario) {
        var CACHE_ID = 'creas-integr-pf';
        var cache = self.$cacheFactory.get(CACHE_ID) || self.$cacheFactory(CACHE_ID);
        cache.put('backUrl', self.$location.path());
        self.$state.transitionTo('censimentoPersonaFisica', {
            idAnagrafica: firmatario.idAnagrafica,
            ndg: firmatario.ndg,
            retId: CACHE_ID
        }, {
            reload: true,
            notify: true
        });
    };

    /**
	 * @ngdoc method
	 * @name eseguiIntegrazioneCliente
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasIntegrazioneAnagrafica
	 * @description Esegue l'integrazione dei dati del cliente
	 */
    this.eseguiIntegrazioneCliente = function() {
    	var CACHE_ID = 'creas-integr-pg';
    	var DEST_ROUTE = 'censimentoPersonaGiuridica';
    	if(self.datiCliente.anagrafica.formaCostitutiva === 'IND'){
    		CACHE_ID = 'creas-integr-pf';
        	DEST_ROUTE = 'censimentoPersonaFisica';
    	}    	
        var cache = self.$cacheFactory.get(CACHE_ID) || self.$cacheFactory(CACHE_ID);
        cache.put('backUrl', self.$location.path());
        self.$state.transitionTo(DEST_ROUTE, {
            idAnagrafica: self.datiCliente.anagrafica.idAnagrafica,
            ndg: self.datiCliente.anagrafica.ndg,
            retId: CACHE_ID
        }, {
            reload: true,
            notify: true
        });
    };

    this.recuperaDatiCliente();
  };

  CreasIntegrazioneAnagraficaCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    '$cacheFactory',
    '$location',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasValutazionePratica/creasIntegrazioneAnagrafica/creasIntegrazioneAnagrafica.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasIntegrazioneAnagraficaComponent = {
    bindings: {},
    controller: CreasIntegrazioneAnagraficaCtrl,
    controllerAs: 'creasIntegrazioneAnagraficaCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component(
      'creasIntegrazioneAnagrafica',
      CreasIntegrazioneAnagraficaComponent
    );
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasValutazionePratica/creasIntegrazioneAnagrafica/creasIntegrazioneAnagrafica.cmpt.js
// module id = 23
// module chunks = 0 1